export const LoginAssociateStepKeys = [
  _TL_('Add a payment method by {{expireDate}}'),
  _TL_('Spend {{upfrontSpend}} in advertising'),
];

export const LoginAssociateStepKeysTaxable = [
  _TL_('Add a payment method by {{expireDate}}'),
  _TL_('Spend {{upfrontSpend}} in advertising (excluding taxes)'),
];

export const SignupSuccessStepKeys = [
  _TL_('Add a campaign'),
  _TL_('Add a payment method by {{expireDate}}'),
  _TL_('Spend {{upfrontSpend}} in advertising'),
];

export const SignupSuccessStepKeysTaxable = [
  _TL_('Add a campaign'),
  _TL_('Add a payment method by {{expireDate}}'),
  _TL_('Spend {{upfrontSpend}} in advertising (excluding taxes)'),
];

export const ServerI18nKeyMap = {
  Brief_SignupEvent: _TL_('Welcome to Microsoft Advertising!'),
  Notification_lightbox_Coupon_Message_Signup_Failure_ContactSupport: _TL_('We encountered a snag while printing your promotional code. Sorry about that! Please {{supportLinkStart}}contact support{{supportLinkStop}} to get your promotional code. {{offerLinkStart}}Offer details{{offerLinkStop}}'),
  Notification_lightbox_Coupon_Message_Signup_Failure_Generic: _TL_("We're sorry, you don't qualify for a new customer offer. {{offerLinkStart}}Offer details{{offerLinkStop}}"),
  Notification_lightbox_Coupon_Message_Signup_Failure_PreviouslyAdvertised: _TL_("Because you advertised with us before, you don't qualify for a new customer offer. {{offerLinkStart}}Offer details{{offerLinkStop}}"),
  Notification_lightbox_Coupon_Title_Signup_Failure_ContactSupport: _TL_('Contact us to get your promotional code'),
};
